import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { Heading, Link, Image } from 'shared';
import styles from './Navigation.module.scss';

export interface NavigationProps {
	children?: React.ReactNode;
	className?: string;
	heading?: string;
	navigationItems?: Link[];
	navigationRightItems?: Link[];
	navigationRightImage?: Image;
	externalNavigationItems?: Link[];
}

export const Navigation: React.FC<NavigationProps> = ({
	children,
	className,
	heading,
	navigationItems,
	navigationRightItems,
	navigationRightImage,
	externalNavigationItems,
}) => {
	const location = useLocation();
	return (
		<>
			{externalNavigationItems?.length > 0 ? (
				<nav className={classNames(styles.Navigation___external, className)}>
					<ul className={classNames(styles.Navigation_list, styles.Navigation_list___external)}>
						{externalNavigationItems.map((externalNavItem, index) => (
							<li className={classNames(styles.Navigation_item)} key={index}>
								{externalNavItem?.url ? (
									<Link
										className={classNames(
											styles.Navigation_link,
											index === 0 && styles.Navigation_link___current,
										)}
										url={externalNavItem.url}
									>
										{externalNavItem?.title}
									</Link>
								) : (
									<span className={styles.Navigation_link}>{externalNavItem?.title}</span>
								)}
							</li>
						))}
					</ul>
				</nav>
			) : null}
			<nav
				className={classNames(styles.Navigation, className)}
				role="navigation"
				aria-labelledby="primary-navigation-heading"
			>
				<Heading headingLevel="h6" id="primary-navigation-heading" className={styles.Navigation_heading}>
					{heading}
				</Heading>

				{navigationItems?.length > 0 ? (
					<ul className={classNames(styles.Navigation_list)}>
						{navigationItems.map((navigationItem: Link, index) => (
							<li key={index} className={classNames(styles.Navigation_item)}>
								<Link
									className={classNames(styles.Navigation_link, {
										[styles.Navigation_link___active]: navigationItem.url === location.pathname,
									})}
									url={navigationItem.url}
								>
									{navigationItem.title}
								</Link>
							</li>
						))}
					</ul>
				) : null}
				{navigationRightItems?.length > 0 ? (
					<ul className={classNames(styles.Navigation_list, styles.Navigation_list_rightSide)}>
						{navigationRightItems.map((navigationItem: Link, index) => (
							<li key={index} className={classNames(styles.Navigation_item)}>
								<Link
									className={classNames(styles.Navigation_link, {
										[styles.Navigation_link___active]: navigationItem.url === location.pathname,
									})}
									url={navigationItem.url}
								>
									{navigationItem.title}
								</Link>
							</li>
						))}
					</ul>
				) : null}
				{navigationRightImage?.url ? (
					<ul
						className={classNames(
							styles.Navigation_list,
							styles.Navigation_list_rightSide,
							styles.Navigation_list_image,
						)}
					>
						<li key={1} className={classNames(styles.Navigation_item)}>
							<Image
								sizes="7rem"
								isCover={true}
								isCenter={false}
								url={navigationRightImage.url}
								properties={navigationRightImage?.properties}
							/>
						</li>
					</ul>
				) : null}
				{children}
			</nav>
		</>
	);
};
